export const environment = {
    apiUrl: 'https://reporting-staging.avanacuso.com/api/v1',
    minCalendarDate: new Date(2006, 6, 1)
};
